import { useCallback, useState } from 'react';

export interface FullscreenPageRequest {
	page: number;
	requestId: number;
}

/**
 * Signals the PDF viewer to (re)open fullscreen at a specific page. The monotonic requestId rides
 * alongside the page so re-requesting the same page still re-fires the viewer's effect.
 */
export const useFullscreenPageRequest = () => {
	const [request, setRequest] = useState<FullscreenPageRequest | null>(null);

	const requestPage = useCallback((page: number) => {
		setRequest((current) => ({ page, requestId: (current?.requestId ?? 0) + 1 }));
	}, []);

	return { request, requestPage };
};
